
//'https://capstone3-battleship-server.herokuapp.com'

const config = {
    API_ENDPOINT: 'https://frozen-earth-30884.herokuapp.com',
}

export default config;
